<template>
<div>
 
    <!-- Modal terminar Proceso-->
    <b-modal
      title="Nuevo detalle carga"
      size="xl"
      class="modal-primary"
      v-model="modalShown"
      hide-footer
    >

    
      <b-form @submit.prevent="submit">

          <b-row>
     
            <b-col sm="6">


        <b-form-group label="Producto">
          <b-form-select
            :state="$v.detail.product.$dirty ? !$v.detail.product.$error : null"
            v-model="$v.detail.product.$model"
            @change="getProductSet"
            >
            <option value="">Seleccione</option>
            <option
              v-for="product in products"
              v-bind:value="{ id: product.value, text: product.text }"
            >{{ product.text }}
            </option>
          </b-form-select>
        </b-form-group>

  
        <b-form-group label="Variedad">
          <b-form-select
            :state="$v.detail.variety.$dirty ? !$v.detail.variety.$error : null"
            v-model="$v.detail.variety.$model"
            >
             <option value="">Seleccione</option>
            <option
              v-for="varietie in productSet.varieties"
              v-bind:value="{ id: varietie.value, text: varietie.text }"
            >{{ varietie.text }}
            </option>
          </b-form-select>
        </b-form-group>

     
            <b-form-group
              v-for="(type, index) in productSet.spec_type"
              v-bind:label="type.name"
              :key="index"
              label-for="basicSelect">

              <b-form-select id="specSelect" v-model="detail.specifications[index]">
                <option v-for="spec in type.specs" :key="spec.value" v-bind:value="{value:spec.value,text:spec.text}">{{spec.text}}</option>
              </b-form-select>

            </b-form-group>

      </b-col>


         <b-col sm="6">

                <b-form-group label="Formato">
          <b-form-select
            :state="$v.detail.format.$dirty ? !$v.detail.format.$error : null"
            v-model="$v.detail.format.$model"
            @change = "calcularPesoFormato"
            :options="productSet.containers"/>
        </b-form-group>


           <b-form-group label="Cantidad Pallet">
          <b-form-input
            type="text"
            :state="$v.detail.pallet_quantity.$dirty ? !$v.detail.pallet_quantity.$error : null"
            v-model="$v.detail.pallet_quantity.$model"
            v-on:keyup = "inputSoloNumero"
            placeholder="">
            </b-form-input>
            </b-form-group>


            <b-form-group label="Cantidad Cajas">
          <b-form-input
            type="text"
            :state="$v.detail.quantity_boxes.$dirty ? !$v.detail.quantity_boxes.$error : null"
            v-model="$v.detail.quantity_boxes.$model"
            v-on:keyup = "calcularPeso"
            placeholder="">
            </b-form-input>
            </b-form-group>


           <b-form-group label="Precio por cajas">
          <b-form-input
            type="text"
            :state="$v.detail.price_box.$dirty ? !$v.detail.price_box.$error : null"
            v-model="$v.detail.price_box.$model"
            v-on:keyup = "inputSoloNumeroDecimal"
            placeholder="">
            </b-form-input>
            </b-form-group>

             <b-form-group label="Peso Bruto">
          <b-form-input
            type="text"
            :state="$v.detail.gross_weight.$dirty ? !$v.detail.gross_weight.$error : null"
            v-model="$v.detail.gross_weight.$model"
            :readonly="true" 
            placeholder="">
            </b-form-input>
            </b-form-group>

            <b-form-group label="Peso Neto">
          <b-form-input
            type="text"
            :state="$v.detail.net_weight.$dirty ? !$v.detail.net_weight.$error : null"
            v-model="$v.detail.net_weight.$model"
            :readonly="true" 
            placeholder="">
            </b-form-input>
            </b-form-group>


      </b-col>

        <b-col sm="12">


        
        


      </b-col>

  </b-row>
  <div align="center">
 <b-button type="submit" variant="primary">Guardar</b-button>
  </div>
        
      </b-form>
    </b-modal>



  </div>
</template>

<script>

import {bus} from "../../main";
import {required, numeric, minLength, between} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'

  const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

  export default {
    name: "modalDetalleCarga",
    props: [
      'boarding'
    ],
    data() {
      return {
          modalShown:false,
          detail:{
            format:"",
            product:"",
            variety:"",
            specifications: [],
            pallet_quantity:"",
            quantity_boxes:"",
            price_box:"",
            gross_weight:0,
	          net_weight:0,
          },
          products: "",
          productSet: {
          containers : [],
          varieties : [],
          spec_type : []
          }
          
      }
    },
     validations: {
      detail: {
        format: {required},
        product: {required},
        variety: {required},
        pallet_quantity: {required},
        quantity_boxes: {required},
        price_box: {required},
        gross_weight:{}, 
        net_weight:{}, 
        
       
      }
    },
   
    mounted () {
      this.loadDataForm();
      this.getProducts();
    },
    methods: {
          loadDataForm(){
      
        console.log("");

      },
      submit() {

         this.$v.$touch();
      if (this.$v.$invalid) {
        miniToastr.info("campos requeridos en el formulario", "");
      } else {

        miniToastr.success("Operación realizada con éxito", "");
        this.modalShown=false,
        this.boarding.shipping_detail.push(this.detail);
       
        
        this.detail = {
            format:"",
            product:"",
            variety:"",
            specifications: [],
            pallet_quantity:"",
            quantity_boxes:"",
            price_box:"",
            gross_weight:0,
	          net_weight:0,
          };

            bus.$emit('calcularDetalle',"Nada");
      }


       

    },
     getProducts(){
          this.$axios.get ('/api/comex/companyform/get_products/', {
          params: {
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
          .then(res => {
            this.products = res.data.data
          })
          .catch(error => console.log(errors))
        },

        getProductSet(a) {

          if(typeof a.id === "undefined"){

       
            this.productSet.varieties = [];
            this.productSet.spec_type = [];
             this.productSet.containers = [];

          }else{

            this.$axios.get ('/api/comex/companyform/get_product_set/', {
          params: {
          product_id: a.id,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
            this.productSet.spec_type = res.data.spec_type;
            this.productSet.varieties = res.data.varieties;

        })
       .catch(error => {
          console.log(error.response)
        });

        const url = 'std' ? 'std' : 'bulk';
          this.$axios.get ('/api/v1/container/' + this.detail.product.id + '/' + url + '/')
          .then(res => {

            this.productSet.containers = res.data
            this.productSet.containers.unshift({"value":"","text":"Seleccione"});

          })
            .catch(error => {
          console.log(error.response)
        });


          }


      },
       inputSoloNumero(event) {

     event.target.value = event.target.value.replace(/[^0-9]/, '');

    },
     inputSoloNumeroDecimal(event) {

     event.target.value = event.target.value.replace(/[^0-9.]/, '');

    },
     calcularPeso() {

      event.target.value = event.target.value.replace(/[^0-9]/, '');

      if(this.detail.quantity_boxes != "")
      {

      let net_weight = parseFloat(this.detail.quantity_boxes) * parseFloat(this.detail.format.net_weight);
      let gross_weight = parseFloat(this.detail.quantity_boxes) * parseFloat(this.detail.format.gross_weight);

      this.detail.gross_weight= gross_weight.toFixed(2);
      this.detail.net_weight= net_weight.toFixed(2);

      }

     

    },
    calcularPesoFormato() {

      if(this.detail.quantity_boxes != "")
      {

      let net_weight = parseFloat(this.detail.quantity_boxes) * parseFloat(this.detail.format.net_weight);
      let gross_weight = parseFloat(this.detail.quantity_boxes) * parseFloat(this.detail.format.gross_weight);

      this.detail.gross_weight= gross_weight.toFixed(2);
      this.detail.net_weight= net_weight.toFixed(2);

      }

     

    },
   
      },
    
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
